module.exports = require('./dist/Sticky');



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-stickynode/index.js
// module id = 140
// module chunks = 53